export const OrderHandler: Record<string, string> = {
  ServiceProvider: "Service provider",
  PortingDotCom: "NumHub",
  Automated: "NumHub (automated)"
};
